export default __webpack_public_path__ + "static/media/claim-prizes@2x.d2ca9869.png";